import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { IMedication } from '../../caremap/ICareMap';

// structure returned from API
type IMedicationSchema = {
    medication_name?: string;
    instructions?: string;
    dose?:  string;
    rx_number?:  string;
    refills?:   string;
    expiration?:  string;
};

export class MedicationService {
    static inject = () => [APIClient];

    constructor(private apiClient: APIClient) {};

    parseMedicationText = async ({ content }: { content: string }): Promise<IMedication> => {
        const entry = await this.apiClient.entry();

        if (!entry.links.processMedicationText) {
            throw new Error('no access to process medications');
        }

        const result = await this.apiClient.post(entry.links.processMedicationText, { content }) as IMedicationSchema;

        return {
            name: result.medication_name || '',
            instructions: result.instructions,
            dose: result.dose,
            rxNumber: result.rx_number,
            refills: result.refills,
            expiration: result.expiration
        };
    };
};
